import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './components/App/App';
import './index.css';
import i18n from './i18n';

export const UNKNOWN_EMAIL = 'unknown@unknown.com';

// App script in page will
// provide the id to mount.
// Taken from https://stackoverflow.com/questions/53562804/how-to-include-the-same-react-app-twice-on-the-same-page
window.mount = function (id) {

  const element = document.getElementById(id);

  // the id of the div to render too
  let windowAppId = `${process.env.REACT_APP_WINDOW_APP_ID}` ? `${process.env.REACT_APP_WINDOW_APP_ID}` : 'portfolioMapper';
  let initParams = {};

  // optionally load attributes from script tag
  function getSyncScriptParams() {
    const scripts = document.getElementsByTagName('script');
    const lastScript = scripts[scripts.length - 1];
    const scriptName = lastScript;

    // Get document attributes
    if (scriptName.getAttribute('configId')) {
      initParams.configId = scriptName.getAttribute('configId');
    } else {
      initParams.configId = '';
    }

    initParams.wtRegion = window[windowAppId] && `${window[windowAppId].wtRegion}` && `${window[windowAppId].wtRegion}` !== 'undefined' ? `${window[windowAppId].wtRegion}` : "US";
    initParams.entityCCY = window[windowAppId] && `${window[windowAppId].entityCCY}` && `${window[windowAppId].entityCCY}` !== 'undefined' ? `${window[windowAppId].entityCCY}` : "USD";
    initParams.tenant = window[windowAppId] && `${window[windowAppId].tenant}` && `${window[windowAppId].tenant}` !== 'undefined' ? `${window[windowAppId].tenant}` : "wisdomtree";
    initParams.clientEmail = window[windowAppId] && `${window[windowAppId].clientEmail}` && `${window[windowAppId].clientEmail}` !== 'undefined' ? `${window[windowAppId].clientEmail}` : UNKNOWN_EMAIL;
    initParams.token = window[windowAppId] && `${window[windowAppId].token}`;
    initParams.isoCode = window[windowAppId] && `${window[windowAppId].isoCode}` && `${window[windowAppId].isoCode}` !== 'undefined' ? `${window[windowAppId].isoCode}` : "en-US";

    initParams.dataspanApiUrl = `${process.env.REACT_APP_API_URL}`;
    initParams.dpdApiUrl = `${process.env.REACT_APP_DPD_URL}`;  
    initParams.version = `${process.env.REACT_APP_VERSION}` !== 'undefined' ? `${process.env.REACT_APP_VERSION}` : 'DEV';
    // Change the language to that specified in the page.
    i18n.changeLanguage(initParams.isoCode);
  }
  getSyncScriptParams();

  // Get the config ID for the Seismic document. This is not the libraryContentVersionId any longer as more than one config can be 
  // used by Seismic document
  initParams.configId = element.dataset.configid ? element.dataset.configid : '';

  // Get the button text (if provided)
  initParams.buttonText = element.dataset.buttontext ? element.dataset.buttontext : '';

  // Get the adhocInputs (if provided)
  initParams.adhocInputs = element.dataset.adhocinputs ? JSON.parse(element.dataset.adhocinputs) : null;

  // Get the open model on load flag - straight to modal
  initParams.openModalOnLoad = element.dataset.openmodalonload ? true : false;

  // specify if this app should allow anonymous runs
  initParams.isAnonymous = element.dataset.isanonymous ? true : false;

  // render
  ReactDOM.render((

    <BrowserRouter>
      <App dataProps={element.dataset} params={initParams} />
    </BrowserRouter>

  ),
    element);

}